import {IconProps} from '../../icons';
import {colors} from '../../styles';

export const inputIconProps: Partial<IconProps> = {
  color: colors.iconGray,
};
